// extracted by mini-css-extract-plugin
export default {"h1":"Title_h1__8LBMQ","h2":"Title_h2__f06vK","h3":"Title_h3__juOEs","noMargin":"Title_noMargin__L1dUa","error":"Title_error__B9CmU"};